export default __webpack_public_path__ + "static/media/logo-short.12a1cc59.png";